import React, { useEffect, useState, useRef } from "react";
import cssClasses from "../../Components/Leads/Leads.module.css";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import { Button as MUIButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import DropDown from "../../Subcomponents/DropDown";
import SearchBar from "../../Subcomponents/Search";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
// import LeadCard from "./../../Subcomponents/userCard/LeadCard";

import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import PlusIcon from "../Icons/PlusIcon";
import { DataGrid } from "@mui/x-data-grid";
import Dot from "../Icons/Dot";
import WhatsApp from "../Icons/WhatsApp";
import AddLead from "../../Modals/AddLead/AddLead";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Collapse from "@mui/material/Collapse";


import debounce from "lodash.debounce";
//SERVICE
import {
  getAgreementDoneLeads,
  getCpInvoiceDetails,
  getFVPaymentHistoryByCPpaymentId,
  getLeads,
  getUsers,
} from "../../Services/LeadService";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost, offlineToast } from "../../Services/Toast";
import { Network } from "@capacitor/network";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import checked from "../../Assets/Images/checked.svg";
import DateComponent from "../../Subcomponents/DateComponent";
import { handleErrors } from "../../Services/LoginService";
import { useNavigate } from "react-router-dom";

import InfiniteScroll from "react-infinite-scroll-component";
// Icons
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/Group26795.svg";
import { uniqBy } from "lodash";
import AgreementLeadCard from "./AgreementLeadCard";
import AgreementLeadCard1 from "./AgreementLeadCard1";
import GuideCollapse from "./Guide/GuideCollapse";

import * as XLSX from "xlsx";

export default function Agreement1() {
  const dispatch = useDispatch();
  const [addLeadModal, setAddLeadModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [hideAddLead, setHideLead] = useState(false);
  const [search, setSearch] = useState("");
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("Latest First");
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [count, setCount] = useState(0);
  //sort by
  const [showDropDown, setShowDropDown] = useState(false);
  const [listOfDropDown, setListOfDropDown] = useState([
    { label: "Status", select: false },
    { label: "Date", select: false },
  ]);

  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [salescheckBox, setSalesCheckbox] = useState([]);
  const [showSalesValues, setShowSalesValues] = useState(false);
  const [projectcheckBox, setProjectCheckbox] = useState([]);
  const [showprojectValues, setShowprojectValues] = useState(false);
  const [statuscheckBox, setStatusCheckbox] = useState([
    { label: "Pending For Invoice", value: false },
    { label: "Pending", value: false },
    { label: "InReview", value: false },
    { label: "Payment In Process", value: false },
    { label: "Partial Payment Done", value: false },
    { label: "Full Payment Done", value: false },
    { label: "APPROVED", value: false },
    { label: "REJECTED", value: false },
  ]);
  const [showStatusValues, setShowStatusValues] = useState(false);
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  //selected Values
  const [selectedDates, setSelectedDate] = useState(null);
  // const [selectedSales, setSelectedSales] = useState([]);
  // const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [showDates, setShowDates] = useState(false);
  const [leadsPresent, setLeadsPresent] = useState(null);
  const navigate = useNavigate();
  const [AllLeads, setAllLeads] = useState([]);
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [storedData, setStoredData] = useState(false);
  const [showGuide, setShowGuide] = useState(false);

  const IsAgreementsVisible = React.useMemo(() => {
    return (
      loggedInUser?.type === "CP" && loggedInUser?.IsAgreementsVisible === true
    );
  }, [loggedInUser?.type, loggedInUser?.IsAgreementsVisible]);

  useEffect(() => {
    dispatch(action.activeMenu("agreement"));
    if (loggedInUser.cpType === "Entity") {
      setHideLead(true);
    }
    // Fetch leads when the component is mounted
    getAgreementDoneLeadsData();
  }, []);

  // Fetch leads data
  const getAgreementDoneLeadsData = (
    _selectedStatus = [],
    _selectedDates = selectDates,
    _search = ""
  ) => {
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getAgreementDoneLeads(
          loggedInUser?.cpId,
          _selectedStatus,
          _selectedDates,
          _search
        )
          .then((resp) => {
            const uniqueLeads = uniqBy(resp.data, "id");
            setAllLeads(uniqueLeads);
            setCount(resp.count);
            setLeadsPresent(resp.count > 0);
            dismissLoader();
          })
          .catch((err) => {
            dismissLoader();
            console.error(err);
            offlineToast();
          });
      } else {
        offlineToast();
      }
    });
  };

  console.log("AllLeads", AllLeads);
  function buttonResp(respValue) {
    if (respValue) {
      setAllLeads([]);
      setPageNumber(0);
      document.getElementById("input-with-icon-textfield leadSearch").value =
        "";
      setSearch("");
      setTimeout(() => {
        Network.getStatus().then((status) => {
          if (status.connected) {
            getAgreementDoneLeads(
              0,
              [],
              [],
              [],
              selectDates,
              null,
              "",
              "Latest First"
            );
          } else {
            offlineToast();
          }
        });
      }, 100);
    }
  }

  // function getMoreData() {
  //   console.log("pageNumber", pageNumber);
  //   console.log("loadingStatus =>", loadingStatus);
  //   if (loadingStatus !== 0) return;
  //   setLoadingStatus(1);
  //   Network.getStatus().then((status) => {
  //     if (status.connected) {
  //       presentLoader();
  //       getAgreementDoneLeads(
  //         loggedInUser.cpId,
  //         loggedInUser.fosId,
  //         pageNumber * pageSize,
  //         pageNumber * pageSize + pageSize - 1,
  //         // selectedSales,
  //         selectedProjects,
  //         selectedStatus,
  //         selectDates,
  //         selectedDates,
  //         search,
  //         drpDownSelectedVal
  //       )
  //         .then((resp) => {
  //           dismissLoader();
  //           console.log(resp);
  //           if (resp.count > resp.data.length + AllLeads.length) {
  //             setLoadingStatus(0);
  //             setPageNumber(pageNumber + 1);
  //           } else {
  //             setLoadingStatus(-1);
  //             setPageNumber(0);
  //           }
  //           setCount(resp.count);
  //           resp.data = resp.data.map((el, index) => ({
  //             ...el,
  //             id: index,
  //             personName: el?.leadname,
  //             email: el?.leademail ?? "-",
  //             leadId: el?.id,
  //             phoneNumber: el?.leadcontactnumber ?? "-",
  //             status: el?.leadstatus ?? "-",
  //             FOS: el?.fosname ?? "-",
  //             leadDisplayId: el?.leaddisplayid ?? "-",
  //           }));
  //           setAllLeads((pre) => [...pre, ...resp.data]);
  //         })
  //         .catch((err) => {
  //           dismissLoader();
  //           console.log(err);
  //           handleErrors(err, "scroll-get-Leads");
  //         });
  //       setLoadingStatus(0);
  //     } else {
  //       offlineToast();
  //     }
  //   });
  // }

  console.log("AllLeads", AllLeads);

  useEffect(() => {
    if (!IsAgreementsVisible) {
      navigate("/Home", { replace: true });
      return;
    }
  }, [IsAgreementsVisible, navigate]);

  const debouncedFetchSearchData = useRef(
    debounce(async (searchText, statusFilters, dateFilters) => {
      const query = typeof searchText === "string" ? searchText.trim() : "";

      if (query.length < 2) {
        getAgreementDoneLeadsData(statusFilters, dateFilters);
        return;
      }

      Network.getStatus().then((statusObj) => {
        if (statusObj.connected) {
          presentLoader();
          getAgreementDoneLeads(
            loggedInUser?.cpId,
            statusFilters,
            dateFilters,
            query
          )
            .then((resp) => {
              const uniqueLeads = uniqBy(resp?.data || [], "id");
              setAllLeads(uniqueLeads);
              setCount(resp.count);
              setLeadsPresent(uniqueLeads.length > 0); // ✅ key fix here
              dismissLoader();
            })
            .catch((err) => {
              dismissLoader();
              console.error(err);
              offlineToast();
            });
        } else {
          offlineToast();
        }
      });
    }, 500)
  ).current;

  const handleSearchInput = (e) => {
    const value = e?.target?.value ?? "";
    debouncedFetchSearchData(value, selectedStatus, selectDates);
  };

//excel
const handleDownloadExcel = async () => {
  if (!AllLeads.length) return;

  const formatIndianCurrency = (amount) => {
    if (!amount || isNaN(amount)) return "₹ 0";
    const roundedAmount = Math.round(Number(amount));
    const amountStr = roundedAmount.toString();
    const lastThree = amountStr.slice(-3);
    const otherNumbers = amountStr.slice(0, -3);
    const formatted =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      (otherNumbers ? "," : "") +
      lastThree;
    return `₹ ${formatted}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const leadsWithPayments = await Promise.all(
    AllLeads.map(async (lead) => {
      let totalAmount = 0;

      try {
        // Step 1: Fetch invoice(s) for this lead
        const invoiceResp = await getCpInvoiceDetails(lead.id);
        const invoices = invoiceResp?.data ?? [];

        if (invoices.length) {
          // Use latest invoice
          const latestInvoice = invoices.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          )[0];

          const invoiceId = latestInvoice?.invoicesId;

          // Step 2: Fetch FV Payment History
          const fvPaymentData = await getFVPaymentHistoryByCPpaymentId(invoiceId);

          totalAmount = fvPaymentData?.reduce(
            (sum, item) => sum + (Number(item?.Amount) || 0),
            0
          );
        }
      } catch (err) {
        console.error(`❌ Error fetching payments for lead ${lead.id}`, err);
      }

      return {
        "Lead CUID": lead?.leadData?.leadDisplayId
          ? `VJ${lead.leadData.leadDisplayId}`
          : "",
        "Lead Name": lead?.personData?.name ?? "",
        "Booking Date": formatDate(lead?.allotmentPaymentData?.created_at),
        "Agreement Date": formatDate(lead?.AgreementDate),
        "Project": lead?.projectData?.projectName ?? "",
        "Wing": lead?.wingData?.wingName ?? "",
        "Unit No": lead?.inventoryDataForLead?.unitNo ?? "",
        "Unit Type": lead?.inventoryDataForLead?.displayUnitType ?? "",
        "Agreement Value": formatIndianCurrency(lead?.Agreement_Value),
        "Basic Brokerage": formatIndianCurrency(lead?.Brokerage_Amount_Basic),
        "Payment Status": lead?.Status ?? "",
        "Paid Amount": formatIndianCurrency(totalAmount),
      };
    })
  );

  // Export to Excel
  const worksheet = XLSX.utils.json_to_sheet(leadsWithPayments);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "AgreementLeads");

  XLSX.writeFile(workbook, "AgreementsData.xlsx");
};




  return (
    <div className={cssClasses.wrapperPage} id="scrollableDiv">
      {/* Header row with heading + subtitle on left and button on right */}
      <div
        className={cssClasses.wrapperHeader}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "1rem",
          marginBottom: "1rem",
        }}
      >
        <div>
          <div className={cssClasses.headerTitle}>Agreements</div>
          <div className={cssClasses.headerSubTitle}>
            Manage your Lead's Agreement here.
          </div>
        </div>

        <div>
          <button
            onClick={() => setShowGuide((prev) => !prev)}
            style={{
              color: "#1570EF",
              borderRadius: "2.4rem",
              // backgroundColor: "#EFF8FF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              border: "1px solid #EFF8FF",
              padding: "0.6rem 1.2rem",
              display: "flex",
              alignItems: "center",
              gap: "0.4rem",
              cursor: "pointer",
            }}
          >
            {showGuide ? "Hide Guide" : "View Guide"}
            {showGuide ? (
              <KeyboardArrowUpIcon
                style={{ color: "#1570EF", width: "2.4rem", height: "2.4rem" }}
              />
            ) : (
              <KeyboardArrowDownIcon
                style={{ color: "#1570EF", width: "2.4rem", height: "2.4rem" }}
              />
            )}
          </button>
        </div>
      </div>

      {/* Collapsible Guide Area - BELOW the header but NOT affecting its position */}
      <Collapse in={showGuide} timeout="auto" unmountOnExit>
        <div
          style={{
            marginBottom: "1.5rem",
            // backgroundColor: "#F9FAFB",
            borderRadius: "8px",
            padding: "1.5rem",
          }}
        >
          <GuideCollapse open={true} />
        </div>
      </Collapse>

      <div className={cssClasses.wrapperFilters}>
        <div className={cssClasses.wrapperNameDropDown}>
          <div className={cssClasses.allLeadsTitle}>{count} Leads </div>
          <div className={cssClasses.wrapperFilter}>
            {/* <div className={cssClasses.filterTitle}>Filter by</div> */}
            <div className={cssClasses.wrapperDropDown}>
              <div
                className={cssClasses.wrapperCustomiseDropDown}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropDown(!showDropDown);
                }}
              >
                <div className={cssClasses.dropDownLabel}>
                  <span className={cssClasses.dropDownLabelValue}>
                    {selectedListDropDown.join()}
                  </span>
                  {selectedListDropDown.length === 0 && (
                    <span className={cssClasses.dropDownLabelValue}>None</span>
                  )}
                </div>
                {showDropDown && (
                  <KeyboardArrowUpIcon className={cssClasses.dropDownIcon} />
                )}
                {showDropDown === false && (
                  <KeyboardArrowDownIcon className={cssClasses.dropDownIcon} />
                )}
              </div>
              {showDropDown && (
                <ClickAwayListener
                  onClickAway={() => {
                    setShowDropDown(false);
                  }}
                >
                  <div className={cssClasses.containerCustomiseDropDown}>
                    <div className={cssClasses.wrapperSelectAndCheckbox}>
                      <div className={cssClasses.wrapperEachSelect}>
                        {listOfDropDown.map((each, index) => {
                          return (
                            <div
                              className={
                                each.select
                                  ? cssClasses.selectedVal
                                  : cssClasses.containerEachSelect
                              }
                            >
                              <div
                                className={cssClasses.eachSelect}
                                onClick={() => {
                                  if (each.label === "None") {
                                    // Clear everything
                                    setSelectedListDropDown([]);
                                    setListOfDropDown((pre) =>
                                      pre.map((item) => ({
                                        ...item,
                                        select: false,
                                      }))
                                    );
                                    setStatusCheckbox((pre) =>
                                      pre.map((item) => ({
                                        ...item,
                                        value: false,
                                      }))
                                    );
                                    setSelectedStatus([]);
                                    setShowStatusValues(false);
                                    setShowDates(false);
                                    setSelectedDate(null);
                                    setSelectDates([
                                      { label: "StartDate", value: "" },
                                      { label: "EndDate", value: "" },
                                    ]);
                                    return;
                                  }

                                  // Toggle selection for current item
                                  setListOfDropDown((pre) =>
                                    pre.map((item) => ({
                                      ...item,
                                      select: item.label === each.label,
                                    }))
                                  );

                                  // Mark selected filter
                                  if (
                                    !selectedListDropDown.includes(each.label)
                                  ) {
                                    setSelectedListDropDown((prev) => [
                                      ...prev,
                                      each.label,
                                    ]);
                                  }

                                  // Show appropriate UI
                                  if (each.label === "Status") {
                                    setShowStatusValues(true);
                                    setShowDates(false);
                                  } else if (each.label === "Date") {
                                    setShowDates(true);
                                    setShowStatusValues(false);
                                  }
                                }}
                              >
                                <span> {each.label}</span>

                                {each.select && (
                                  <img
                                    src={checked}
                                    alt={"checked"}
                                    // style={{ marginRight: "2rem" }}
                                  />
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className={cssClasses.wrapperCheckbox}>
                        {showSalesValues &&
                          salescheckBox.map((each, index) => {
                            return (
                              <FormGroup>
                                <FormControlLabel
                                  sx={[
                                    {
                                      "& .MuiTypography-root": {
                                        fontFamily: "Inter-Medium !important",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        fontSize: "1.6rem !important",
                                        lineHeight: "2.4rem !important",
                                        /* identical to box height, or 150% */

                                        /* Gray/900 */

                                        color: "#101828",
                                        textTransform: "capitalize",
                                      },
                                    },
                                  ]}
                                  // checked={each.value}
                                  // onChange={(e) => {
                                  //   console.log(e.target.checked);
                                  //   if (e.target.checked) {
                                  //     setSalesCheckbox((pre) => {
                                  //       pre[index].value = e.target.checked;
                                  // selectedSales.push(each.id);
                                  //       return [...pre];
                                  //     });
                                  //   } else {
                                  //     setSalesCheckbox((pre) => {
                                  //       pre[index].value = e.target.checked;
                                  //       return [...pre];
                                  //     });
                                  //     setSelectedSales(
                                  //       selectedSales.filter(
                                  //         (id) => id !== each.id
                                  //       )
                                  //     );
                                  //   }
                                  //   let checkSalesSelected =
                                  //     salescheckBox.filter(
                                  //       ({ value }) => value === true
                                  //     );
                                  //   if (checkSalesSelected.length > 0) {
                                  //     setListOfDropDown((pre) => {
                                  //       pre[2].select = true;
                                  //       return [...pre];
                                  //     });
                                  //     if (
                                  //       selectedListDropDown.find(
                                  //         (value) => value === "Sales"
                                  //       ) === undefined
                                  //     ) {
                                  //       setSelectedListDropDown((pre) => {
                                  //         console.log("pre: ", pre);
                                  //         return [...pre, "Sales"];
                                  //       });
                                  //     }
                                  //   } else {
                                  //     setListOfDropDown((pre) => {
                                  //       pre[2].select = false;
                                  //       return [...pre];
                                  //     });
                                  //     setSelectedListDropDown((pre) => [
                                  //       ...pre.filter(
                                  //         (value) => value !== "Sales"
                                  //       ),
                                  //     ]);
                                  //   }
                                  // }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          fontSize: 28,
                                        },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            );
                          })}

                        {showStatusValues &&
                          statuscheckBox.map((each, index) => {
                            return (
                              <FormGroup>
                                <FormControlLabel
                                  sx={[
                                    {
                                      "& .MuiTypography-root": {
                                        fontFamily: "Inter-Medium !important",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        fontSize: "1.6rem !important",
                                        lineHeight: "2.4rem !important",
                                        /* identical to box height, or 150% */

                                        /* Gray/900 */

                                        color: "#101828",
                                      },
                                    },
                                  ]}
                                  checked={each.value}
                                  onChange={(e) => {
                                    console.log(e.target.checked);
                                    if (e.target.checked) {
                                      setStatusCheckbox((pre) => {
                                        pre[index].value = e.target.checked;
                                        selectedStatus.push(each.label);
                                        return [...pre];
                                      });
                                    } else {
                                      setStatusCheckbox((pre) => {
                                        pre[index].value = e.target.checked;
                                        return [...pre];
                                      });
                                      setSelectedStatus(
                                        selectedStatus.filter(
                                          (status) => status !== each.label
                                        )
                                      );
                                    }
                                    let checkStatusSelected =
                                      statuscheckBox.filter(
                                        ({ value }) => value === true
                                      );
                                    if (checkStatusSelected.length > 0) {
                                      setListOfDropDown((pre) =>
                                        pre.map((item) =>
                                          item.label === "Status"
                                            ? { ...item, select: true }
                                            : item
                                        )
                                      );

                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === "Status"
                                        ) === undefined
                                      ) {
                                        selectedListDropDown.push("Status");
                                      }
                                    } else {
                                      setListOfDropDown((pre) => {
                                        pre[4].select = false;
                                        return [...pre];
                                      });
                                      setSelectedListDropDown([
                                        ...selectedListDropDown.filter(
                                          (value) => value !== "Status"
                                        ),
                                      ]);
                                    }
                                  }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          fontSize: 28,
                                        },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            );
                          })}

                        {showDates && (
                          <div>
                            <div className={cssClasses.dateDivider}>
                              <div
                                className={cssClasses.label}
                                style={{ marginBottom: "0.5rem" }}
                              >
                                Start Date
                              </div>
                              <DateComponent
                                value={selectDates[0].value}
                                minDate={"1 Jan"}
                                onChangeDate={(value) => {
                                  console.log(value);
                                  setSelectedDate("notNull");
                                  setSelectDates((pre) => {
                                    const newDates = [...pre];
                                    newDates[0].value = value;
                                    return newDates;
                                  });

                                  setHelperText((pre) => {
                                    pre.endDate = "";
                                    return { ...pre };
                                  });
                                }}
                                helperText={helperText.startDate}
                              ></DateComponent>
                            </div>
                            <div>
                              <div
                                className={cssClasses.label}
                                style={{ marginBottom: "0.5rem" }}
                              >
                                End Date
                              </div>
                              <DateComponent
                                value={selectDates[1].value}
                                minDate={"1 Jan"}
                                onChangeDate={(value) => {
                                  setSelectedDate("notNull");
                                  console.log(selectDates[0].value, value);
                                  if (selectDates[0].value === "") {
                                    setHelperText((pre) => {
                                      pre.endDate =
                                        "Please select start date first";
                                      return { ...pre };
                                    });
                                  } else {
                                    if (selectDates[0].value > value) {
                                      setHelperText((pre) => {
                                        pre.endDate =
                                          "Select End Date Greater than start Date";
                                        return { ...pre };
                                      });
                                    } else {
                                      setSelectDates((pre) => {
                                        const newDates = [...pre];
                                        newDates[1].value = value;
                                        return newDates;
                                      });

                                      setHelperText((pre) => {
                                        pre.endDate = "";
                                        return { ...pre };
                                      });
                                      setListOfDropDown((pre) => {
                                        pre[1].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === "Date"
                                        ) === undefined
                                      ) {
                                        selectedListDropDown.push("Date");
                                      }
                                    }
                                  }
                                }}
                                helperText={helperText.endDate}
                              ></DateComponent>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={cssClasses.wrapperDropDownButtons}>
                      <div>
                        <Button
                          style={{
                            color: "#344054",
                            backgroundColor: "#ffffff",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                          }}
                          padding={"0.8rem"}
                          btnName={"Clear"}
                          clicked={() => {
                            setSelectedListDropDown([]);
                            setStatusCheckbox((pre) =>
                              pre.map((item) => ({
                                ...item,
                                value: false,
                              }))
                            );
                            setSelectedStatus([]);

                            // Reset date filters
                            const clearedDates = [
                              { label: "StartDate", value: "" },
                              { label: "EndDate", value: "" },
                            ];
                            setSelectDates(clearedDates);
                            setShowStatusValues(false);
                            setShowDates(false);
                            setSelectedDate(null);

                            // Fetch all data without filters
                            getAgreementDoneLeadsData([], clearedDates);
                          }}
                        />
                      </div>
                      <div>
                        <Button
                          style={{
                            color: "#ffffff",
                            backgroundColor: "#1570EF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                          }}
                          padding={"0.8rem"}
                          btnName={"Apply"}
                          clicked={() => {
                            Network.getStatus().then((status) => {
                              if (status.connected) {
                                getAgreementDoneLeadsData(
                                  selectedStatus,
                                  selectDates
                                );
                                setShowDropDown(false);
                              } else {
                                offlineToast();
                              }
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              )}
            </div>
          </div>
          {/* <div className={cssClasses.wrapperSortDropDown}> */}
          {/* <div>Filter By</div> */}
          {/* <DropDown
              list={[
                "Name Ascending",
                "Name Descending",
                "Latest First",
                "Oldest First",
              ]}
              selectedValue={drpDownSelectedVal}
              onChangeSelect={(_value) => {
                setDrpDownSelectedVal(_value);
                Network.getStatus().then((status) => {
                  if (status.connected) {
                    getAgreementDoneLeads(
                      0,
                      // selectedSales,
                      selectedProjects,
                      selectedStatus,
                      selectDates,
                      selectedDates,
                      search,
                      _value
                    );
                    console.log("AllLeads", AllLeads);
                  } else {
                    offlineToast();
                  }
                });
              }}
              placeHolder={"Select"}
              //style.color is placeHolder's color
              style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
              helperText={""}
            /> */}
          {/* </div> */}
        </div>
       <div
  className={cssClasses.wrapperSearchBar}
  style={{ display: "flex", gap: "1rem",}}
>
  <SearchBar
    id={"leadSearch"}
    placeholder={"Search"}
    search={handleSearchInput}
    width="100%"
  />

  <MUIButton
    variant="contained"
    onClick={handleDownloadExcel}
    startIcon={<DownloadIcon />}
    sx={{
      backgroundColor: "#1570EF",
      color: "#ffffff",
      textTransform: "none",
      height: "4.5rem",
      fontSize: "1.5rem",
      whiteSpace: "nowrap",
      width:"80%"
    }}
  >
     Agreement Data
  </MUIButton>
</div>

      </div>
      <div
        className={cssClasses.wrapperTable}
        // onScroll={onScroll}
        // ref={scrollRef}
        id="scrollableDiv"
      >
        {console.log("AllLeads", AllLeads)}

        {AllLeads &&
          uniqBy(AllLeads, "id").map((data) => (
            <AgreementLeadCard1
              data={data}
              key={data?.id}
              returnButtonResp={buttonResp}
            />
          ))}

        {leadsPresent === false && (
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={EmptyListIcon} alt="No Leads" />
            </div>
            <div className={cssClasses.emptyTitle}>No Agreements Done</div>
            {loggedInUser.cpType !== "Entity" && (
              <div className={cssClasses.emptySubTitle}>
                <div className={cssClasses.addLeadBtn}>
                  {/* <Button
                    style={{
                      color: "#fff",
                      backgroundColor: "#175CD3",
                      fontSize: "1.6rem",
                      lineHeight: "2.4rem",
                    }}
                    btnName={"Add Leads"}
                    clicked={() => {
                      setAddLeadModal(true);
                    }}
                    btnIcon={<PlusIcon />}
                    iconPosition={"left"}
                  ></Button> */}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
